var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import config from "@/config";
import CorePanel from "@/prefabs/core/Panel";
var PanelTimer = /** @class */ (function (_super) {
    __extends(PanelTimer, _super);
    function PanelTimer(scene, x, y) {
        var _this = _super.call(this, scene, x, y) || this;
        _this.text_info = new Phaser.GameObjects.Text(_this.scene, 0, 0, "00:00", {
            color: "white",
            fontFamily: config.graphics.fontFamily,
        })
            .setFontSize(40)
            .setOrigin(1, 0.5);
        _this.add(_this.text_info);
        _this.setDepth(9990);
        _this.setScrollFactor(0);
        _this.setTime(config.gameplay.time.repeat);
        _this.x -= _this.text_info.width / 2;
        // RESIZE
        _this.RESIZE_H_FACTOR = 1;
        _this.RESIZE_H_MAX = _this.text_info.height;
        _this.RESIZE_W_FACTOR = 0.1;
        _this.RESIZE_W_MAX = _this.text_info.width;
        return _this;
    }
    PanelTimer.prototype.setPosition = function (x, y, z, w) {
        var _a;
        _super.prototype.setPosition.call(this, x - ((_a = this.text_info) === null || _a === void 0 ? void 0 : _a.width) / 2, y, z, w);
        return this;
    };
    PanelTimer.prototype.setTime = function (time) {
        var m = Math.trunc(time / 60);
        var s = time - m * 60;
        var tm = m.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
        });
        var ts = s.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
        });
        this.text_info.setText("".concat(tm, ":").concat(ts));
    };
    return PanelTimer;
}(CorePanel));
export default PanelTimer;
